import { z } from "zod";
import { RequestParameterDtoSchema } from "./RequestParameterDto";

export const InsertRequestInputSchema = z.object({
    username: z.string().nullish(),
    notificationLinkAddress: z.string().nullish(),
    requestId: z.string().nullish(),
    requestTypeId: z.number(),
    parameters: z.array(RequestParameterDtoSchema).nullish(),
    shouldBeNotified: z.boolean(),
    isUploadFinished: z.boolean().nullish(),
    uploadSessionId: z.string().nullish(),
    clientId: z.string().nullish(),
    ignoreFieldValidations: z.boolean().nullish(),
});

export type InsertRequestInput = z.infer<typeof InsertRequestInputSchema>;